import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1.5 h-8 rounded-full bg-accent-500 shrink-0" />
        <div className="min-w-0">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 tracking-wide">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5 line-clamp-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-primary-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}